window["engagement-finder"] =  window['engagement-finder']  ||  {}
export default {
  name: "AllPublishedPage",
  components: {
    ...window["engagement-finder"].default
  },
  data: () => ({
    language: "fr"
  })
};